import { IConcreteEnvironmentData } from "./IConcreteEnvironmentData";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { IBaseEnvironmentData } from "../../../environment/data/IBaseEnvironmentData";

export class ConcreteEnvironmentData implements IConcreteEnvironmentData, IBaseEnvironmentData {
    private _globals: IEnvironmentGlobals;

    public get globals(): IEnvironmentGlobals {
        return this._globals;
    }

    public set globals(value: IEnvironmentGlobals) {
        this._globals = value;
    }

    public get cdnSubDomain(): string {
        return this._globals.cdnSubDomain;
    }

    public get domain(): string {
        return this._globals.domain;
    }

    public get gameId(): string {
        return !(typeof this._globals.gameId === "undefined") ? this._globals.gameId.toString() : "GAME_ID_NOT_SET";
    }

    public get gameTitle(): string {

        return this._globals.gameTitle;
    }


    /**
     * //TODO @HTML5 HTML-961 HTML-925
     * temp solution because on filetestserver folder have game name..  :'-(
     * @returns {string|string}
     */
    public get officialName(): string {
        return this.gameId == "15" ? "bigfarm" : "empire";
    }

    public get gameFileName(): string {
        return !(typeof this._globals.gameTitle === "undefined") ? this._globals.gameTitle.toLowerCase() : "GAME_TITLE_NOT_SET";
    }

    public get gameVersion(): string {
        return this._globals.versionInformation.versionNumberGame;
    }

    public get formattedGameVersion(): string {
        return this._globals.buildNumberGame;
    }

    public get networkId(): string {
        return this._globals.networkId.toString();
    }

    public get languageCode(): string {
        return this._globals.currentCountryLanguageCode;
    }

    public get baseURL(): string {
        return this._globals.baseURL;
    }

    public get baseAssetsURL(): string {
        return this._globals.baseAssetsURL;
    }

    public get branchId(): string {
        return this._globals.branchId;
    }

    public get branchVersion(): string {
        return this._globals.branchVersion;
    }

    public get featureBranchId(): string {
        return this._globals.featureBranchId;
    }

    public get featureBranchEnvironment(): string {
        return this._globals.featureBranchEnvironment;
    }

    public get countryVersion(): string {
        return "latest";   //TODO @HTML5 HTML-961 HTML-925 set proper path to version number
    }

    public get networkVersion(): string {
        return "latest"; //TODO @HTML5 HTML-961 HTML-925 set proper path to version number
    }

    public get languageVersion(): string {
        return this._globals.currentCountryLanguageVersion.toString();
    }

    public get itemsXMLVersion(): string {
        return this._globals.versionInformation.basicVersionNumberItemsXML;
    }

    public get fontVersion(): string {
        return this._globals.langVersionDict.get(this._globals.currentCountryLanguageCode);
    }

    public get zipSuffix(): string {
        // return "json";
        // TODO: @HTML5  language xml are not xmls anymore, nor ggs zipped  -  but country - network and items  are still xml and zipped
        // (for now i solved the issue with a string replace in  PathProvider.get languageConfigURL():
        return this._globals.useZipXMLs ? "ggs" : "xml";
    }

    public get shopBaseUrl(): string {
        return this._globals.isTest ? "://shop-test" : "://itemshop";
    }

    // not sure if this two are still needed..
    public get protocol(): string {
        return null;
    }

    public get ggsLanguageCode(): string {
        return null;
    }
}
